import React from 'react';
import { getContext } from 'common';
import { getElevationStyle } from 'components/Elevation';
import DialogSheetAnimation from './DialogSheetAnimation';

import Styled from './styles';

export interface DialogSheetContentContainerProps extends React.ComponentPropsWithRef<'div'> {
  /** The content of the DialogSheet, consider using `DialogSheetTitle`, `DialogContent` and `DialogFooter` */
  children: React.ReactNode;
  /** Set `true`, to render the dialog sheet. */
  isOpen?: boolean;
  /** Controls animation(Slide) for content of DialogSheet. See react-spring transition config for more information (https://react-spring.io). */
  animationProps?: any;
  /** If true, disable all motion animation for this component.  This property will override any global disableAnimation setting. */
  disableAnimation?: boolean;
  /** Set `true`, to animate the dialogsheet from bottom */
  editMode?: boolean;
  /** App header ref that calculates the height of it and adjusts the DialogSheet height accordingly. */
  appHeaderRef?: React.RefObject<HTMLElement>;
}

/** DialogSheetContentContainer, All other props are passed to the Container element. */
const DialogSheetContentContainer = React.forwardRef<HTMLElement, DialogSheetContentContainerProps>((props: DialogSheetContentContainerProps, ref) =>
  getContext(({ RTL }) => {
    const {
      isOpen,
      animationProps,
      disableAnimation,
      editMode,
      children,
      appHeaderRef,
      ...otherProps
    } = props;

    const appHeaderHeight = appHeaderRef && appHeaderRef.current && appHeaderRef.current.clientHeight;

    return (
      <DialogSheetAnimation RTL={RTL} isOpen={isOpen} editMode={editMode} {...animationProps} disableAnimation={disableAnimation}>
        <Styled.ContentContainer
          ref={ref}
          $appBanner={appHeaderHeight}
          style={{
            ...getElevationStyle({ elevationIndex: 0 })
          }}
          {...otherProps}
        >
          {children}
        </Styled.ContentContainer>
      </DialogSheetAnimation>
    );
  }));

DialogSheetContentContainer.defaultProps = {
  isOpen: false,
  animationProps: {},
  disableAnimation: undefined,
  editMode: false,
  appHeaderRef: {
    current: undefined
  },
};
DialogSheetContentContainer.displayName = 'DialogSheetContentContainer';
export default DialogSheetContentContainer;
